<template>
  <div class="order">
    <div class="header-tool">
      <div class="header-tool-info">
         <Breadcrumb>
          <BreadcrumbItem to="/exhibition/index">订单中心</BreadcrumbItem>
          <BreadcrumbItem>全部订单</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.nameEn}}</div>
        <Input placeholder="订单号/用户名/手机号" style="width:230px;margin-top:20px;">
          <Icon type="ios-search" slot="suffix" />
        </Input>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="exportOrder()">
          <i class="icon iconfont icon-downLoad2" style="font-size:20px;"></i>
          <span style="margin-left:5px;">导出订单</span>
        </div>
      </div>
    </div>

    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="全部订单" name="1">
          <allOrder ref="allOrder" v-if="String(showTabs) === '1'" />
        </TabPane>
        <TabPane label="待发货" name="2">
          <sendOrder ref="sendOrder" v-if="String(showTabs) === '2'" />
        </TabPane>
        <TabPane label="待收货" name="3">
          <acceptOrder ref="acceptOrder" v-if="String(showTabs) === '3'" />
        </TabPane>
        <TabPane label="已完成" name="4">
          <finishOrder ref="finishOrder" v-if="String(showTabs) === '4'" />
        </TabPane>
      </Tabs>
    </div>

    <Contact />
  </div>
</template>

<script>
import Contact from "@components/Contact/Contact";
import allOrder from "./../components/all-order.vue";
import sendOrder from "./../components/send-order.vue";
import acceptOrder from "./../components/accept-order.vue";
import finishOrder from "./../components/finish-order.vue";
import { mapGetters } from "vuex";

export default {
  name: "exhibition-order-all",
  data() {
    return {
      showTabs: "1",
      refName: "allOrder"
    }
  },
  components: {
    Contact,
    allOrder,
    sendOrder,
    acceptOrder,
    finishOrder
  },
  watch: {
    showTabs(val,oldVal) {
      switch (val) {
        case "1":
          this.refName = "allOrder";
          break;
        case "2":
          this.refName = "sendOrder";
          break;
        case "3":
          this.refName = "acceptOrder";
          break;
        case "4":
          this.refName = "finishOrder";
          break;
      }
    }
  },
  computed: {
    ...mapGetters({ 
      exhibition: "loginModule/getExhibition"
    })
  },
  methods: {
    changeTab() {
      this.showTabs = "1";
      if(this.$route.query && this.$route.query.type && this.$route.query.type === "send") {
        this.showTabs = "2";
      }
      if(this.$route.query && this.$route.query.type && this.$route.query.type === "accept") {
        this.showTabs = "3";
      }
      if(this.$route.query && this.$route.query.type && this.$route.query.type === "finish") {
        this.showTabs = "4";
      }
    },
    switchBrand(name) {
      if(name === "1") {
        this.$router.push(`${this.$route.path}?type=all`)
      } else if(name === "2") {
        this.$router.push(`${this.$route.path}?type=send`)
      } else if(name === "3") {
        this.$router.push(`${this.$route.path}?type=accept`)
      } else if(name === "4") {
        this.$router.push(`${this.$route.path}?type=finish`)
      }
    },
    exportOrder() {
      console.log(this.$refs[`${this.refName}`])
    }
  },
  created() {
    this.changeTab();
  }
}
</script>

<style lang="scss" scoped>
</style>